<template src="./ComandosValidacaoLog.html"></template>
<style src="./ComandosValidacaoLog.css"></style>

<script>
import Filter from "@/components/ComandosValidacaoLog/Filter/Filter";

import store from "@/store";

export default {
  components: {
    "app-component-comandos-validacao-log-filter": Filter
  },
  data() {
    return {
      items: ["Click Me", "Click Me", "Click Me", "Click Me 2"]
    };
  },
  methods: {
    onResize() {
      store.dispatch("setWindowWidth", window.innerWidth);
      store.dispatch("setWindowHeight", window.innerHeight);
    }
  },
  computed: {
    snackBar() {
      return store.state.comandosValidacaoLog.snackBar;
    }
  }
};
</script>